"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Category = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FundRow = _interopRequireDefault(require("../FundRow"));

require("../../Calculator.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Category = /*#__PURE__*/function (_Component) {
  _inherits(Category, _Component);

  var _super = _createSuper(Category);

  function Category() {
    _classCallCheck(this, Category);

    return _super.apply(this, arguments);
  }

  _createClass(Category, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          categoryKey = _this$props.categoryKey,
          funds = _this$props.funds,
          categoryIndex = _this$props.categoryIndex,
          visibleFundIds = _this$props.visibleFundIds,
          showSelectedFundsOnly = _this$props.showSelectedFundsOnly,
          matrixAllocations = _this$props.matrixAllocations,
          isStatic = _this$props.isStatic,
          getBracketError = _this$props.getBracketError,
          onBracketValueChangeHandler = _this$props.onBracketValueChangeHandler,
          onBracketBlurHandler = _this$props.onBracketBlurHandler,
          onFundSelectionHandler = _this$props.onFundSelectionHandler,
          selectedFunds = _this$props.selectedFunds,
          categoryColor = _this$props.categoryColor,
          subCategoryStickyHeaderOffset = _this$props.subCategoryStickyHeaderOffset,
          isViewing = _this$props.isViewing,
          onKeyDown = _this$props.onKeyDown,
          isInternalView = _this$props.isInternalView; // add transparency to rows

      var categoryColorTransp = "".concat(categoryColor, "20");
      var previousFundSubCategoryId = 0;
      return matrixAllocations.length > 0 && funds.map(function (fund, fundIndex) {
        var rows = [];
        var fundKey = "".concat(categoryKey, "_").concat(fund.FundId, "_").concat(fundIndex);
        var isNewSubCategoryId = fund.FundSubCategoryId !== previousFundSubCategoryId;
        if (isNewSubCategoryId) previousFundSubCategoryId = fund.FundSubCategoryId;

        if (isNewSubCategoryId && !showSelectedFundsOnly && !isViewing && !isInternalView) {
          rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
            key: "subasset_".concat(fundKey)
          }, /*#__PURE__*/_react["default"].createElement("th", {
            "data-html2canvas-ignore": true,
            colSpan: "100%",
            className: "subcategory hideOnPrint",
            style: {
              top: "".concat(subCategoryStickyHeaderOffset, "px")
            }
          }, fund.FundSubCategoryName)));
        }

        var visibleFundId = visibleFundIds[categoryIndex][fundIndex];

        if (visibleFundId > -1) {
          rows.push( /*#__PURE__*/_react["default"].createElement(_FundRow["default"], {
            isViewing: isViewing,
            isInternalView: isInternalView,
            isStatic: isStatic,
            visibleFundId: visibleFundId,
            fundIndex: fundIndex,
            categoryColor: categoryColor,
            fundRowBackgroundColor: categoryColorTransp,
            fundKey: fundKey,
            key: fundKey,
            categoryIndex: categoryIndex,
            fund: fund,
            fundValues: matrixAllocations[categoryIndex][fundIndex],
            getBracketError: getBracketError,
            onBracketValueChangeHandler: onBracketValueChangeHandler,
            onBracketBlurHandler: onBracketBlurHandler,
            onFundSelectionHandler: onFundSelectionHandler,
            checked: selectedFunds[categoryIndex][fundIndex],
            onKeyDown: onKeyDown
          }));
        }

        return rows;
      });
    }
  }]);

  return Category;
}(_react.Component);

exports.Category = Category;

_defineProperty(Category, "propTypes", {
  subCategoryStickyHeaderOffset: _propTypes["default"].number.isRequired,
  categoryKey: _propTypes["default"].string.isRequired,
  funds: _propTypes["default"].array.isRequired,
  categoryIndex: _propTypes["default"].number.isRequired,
  showSelectedFundsOnly: _propTypes["default"].bool.isRequired,
  matrixAllocations: _propTypes["default"].array.isRequired,
  getBracketError: _propTypes["default"].func.isRequired,
  onBracketValueChangeHandler: _propTypes["default"].func.isRequired,
  onBracketBlurHandler: _propTypes["default"].func.isRequired,
  onFundSelectionHandler: _propTypes["default"].func.isRequired,
  selectedFunds: _propTypes["default"].array.isRequired,
  categoryColor: _propTypes["default"].string,
  isViewing: _propTypes["default"].bool.isRequired,
  isInternalView: _propTypes["default"].bool.isRequired,
  // hides the subcategory header in this component
  isStatic: _propTypes["default"].bool.isRequired,
  visibleFundIds: _propTypes["default"].array.isRequired,
  onKeyDown: _propTypes["default"].func.isRequired
});

var _default = Category;
exports["default"] = _default;